module.exports = __webpack_public_path__ + "static/media/edi7.7c657765.jpeg";